export const state = {
  errorCode: {
    // login用のエラーコード
    errorCode_110001: 110001,
    errorCode_110002: 110002,
    errorCode_110003: 110003,
    errorCode_110004: 110004,
    // logout用のエラーコード
    errorCode_500001: 500001,
    // device用のエラーコード
    errorCode_340001: 340001,
    errorCode_140001: 140001,
    errorCode_140002: 140002,
    errorCode_140003: 140003,
    errorCode_140004: 140004,
    errorCode_140005: 140005,
    errorCode_140006: 140006,
    errorCode_140007: 140007,
    errorCode_140008: 140008,
    errorCode_140009: 140009,
    errorCode_160001: 160001,
    errorCode_160002: 160002,
    errorCode_160003: 160003,
    errorCode_160004: 160004,
    // place用のエラーコード
    errorCode_350001: 350001,
    errorCode_350002: 350002,
    errorCode_170001: 170001,
    errorCode_170002: 170002,
    errorCode_170003: 170003,
    errorCode_170004: 170004,
    errorCode_170005: 170005,
    errorCode_170006: 170006,
    errorCode_170007: 170007,
    errorCode_170008: 170008,
    errorCode_170009: 170009,
    errorCode_190001: 190001,
    errorCode_190002: 190002,
    errorCode_190003: 190003,
    errorCode_190004: 190004,
    errorCode_190005: 190005,
    // post用のエラーコード
    errorCode_360001: 360001,
    errorCode_200001: 200001,
    errorCode_200002: 200002,
    errorCode_200003: 200003,
    errorCode_200004: 200004,
    errorCode_200005: 200005,
    errorCode_200006: 200006,
    errorCode_200007: 200007,
    errorCode_200008: 200008,
    errorCode_200009: 200009,
    errorCode_220001: 220001,
    errorCode_220002: 220002,
    errorCode_220003: 220003,
    errorCode_220004: 220004,
    // user用のエラーコード
    errorCode_370001: 370001,
    errorCode_370002: 370002,
    errorCode_230001: 230001,
    errorCode_230002: 230002,
    errorCode_230003: 230003,
    errorCode_230004: 230004,
    errorCode_230005: 230005,
    errorCode_230006: 230006,
    errorCode_230007: 230007,
    errorCode_230008: 230008,
    errorCode_230009: 230009,
    errorCode_250001: 250001,
    errorCode_250002: 250002,
    errorCode_250003: 250003,
    errorCode_250004: 250004,
    errorCode_250005: 250005,
    errorCode_250006: 250006,
    errorCode_250007: 250007,
    errorCode_250008: 250008,
    errorCode_250009: 250009,
    // assessmentInfo用のエラーコード
    errorCode_270001: 270001,
    errorCode_270002: 270002,
    errorCode_270003: 270003,
    errorCode_270004: 270004,
    errorCode_270005: 270005,
    errorCode_270006: 270006,
    errorCode_270007: 270007,
    errorCode_270008: 270008,
    errorCode_270009: 270009,
    errorCode_270010: 270010,
    // adminUser用のエラーコード
    errorCode_380001: 380001,
    errorCode_290001: 290001,
    errorCode_290002: 290002,
    errorCode_290003: 290003,
    errorCode_290004: 290004,
    errorCode_290005: 290005,
    errorCode_290006: 290006,
    errorCode_290007: 290007,
    errorCode_290008: 290008,
    errorCode_290009: 290009,
    errorCode_290010: 290010,
    errorCode_310001: 310001,
    errorCode_310002: 310002,
    errorCode_310003: 310003,
    errorCode_310004: 310004,
    errorCode_310005: 310005,
    // log用のエラーコード
    errorCode_320001: 320001,
    errorCode_320002: 320002,
    errorCode_320003: 320003,
    errorCode_320004: 320004,
    // beacon用のエラーコード
    errorCode_420001: 420001,
    errorCode_390001: 390001,
    errorCode_390002: 390002,
    errorCode_390003: 390003,
    errorCode_390004: 390004,
    errorCode_390005: 390005,
    errorCode_390006: 390006,
    errorCode_390007: 390007,
    errorCode_390008: 390008,
    errorCode_390009: 390009,
    errorCode_410001: 410001,
    errorCode_410002: 410002,
    errorCode_410003: 410003,
    errorCode_410004: 410004,
    // master用のエラーコード
    errorCode_430001: 430001,
    errorCode_430002: 430002,
    errorCode_430003: 430003,
    errorCode_430004: 430004,
    errorCode_430005: 430005,
    errorCode_430006: 430006,
    errorCode_430007: 430007,
    errorCode_430008: 430008,
    errorCode_430009: 430009,
    errorCode_430010: 430010,
    errorCode_440001: 440001,
    // controller用のエラーコード
    errorCode_510001: 510001,
    errorCode_510002: 510002,
    // dashboard用のエラーコード
    errorCode_120001: 120001,
    // loginUser用のエラーコード
    errorCode_600001: 600001,
    errorCode_600002: 600002,
    errorCode_600003: 600003,
    // assign用のエラーコード
    errorCode_660001: 660001,
    // 更新予約のエラーコード
    errorCode_700001: 700001
  },
  sysErrorCode: {
    // ログイン画面
    sysErrorCode_100001: 100001,
    sysErrorCode_100002: 100002,
    sysErrorCode_100003: 100003,
    // テナント画面
    sysErrorCode_110001: 110001,
    sysErrorCode_110002: 110002,
    sysErrorCode_130001: 130001,
    sysErrorCode_130002: 130002,
    sysErrorCode_140001: 140001,
    // ログ解析画面
    sysErrorCode_190001: 190001,
    sysErrorCode_190002: 190002,
    sysErrorCode_190003: 190003,
    sysErrorCode_190004: 190004,
    sysErrorCode_190005: 190005,
    sysErrorCode_190006: 190006,
    sysErrorCode_190007: 190007,
    sysErrorCode_190008: 190008,
    sysErrorCode_190009: 190009,
    sysErrorCode_190010: 190010,
    // ログアウト
    sysErrorCode_500001: 500001,
    // パスワード認証
    sysErrorCode_540001: 540001,
    // パスワード変更
    sysErrorCode_570001: 570001,
    sysErrorCode_570002: 570002,
    sysErrorCode_570003: 570003,
    sysErrorCode_570004: 570004,
    // お知らせ情報
    sysErrorCode_580001: 580001,
    // お知らせ管理
    sysErrorCode_590001: 590001,
    sysErrorCode_600001: 600001,
    sysErrorCode_600002: 600002,
    // メール送信
    sysErrorCode_610001: 610001,
    // プライバシーポリシー
    sysErrorCode_620001: 620001,
    // EventHubs SASキー
    sysErrorCode_630001: 630001,
    // 管理者メールアドレス
    sysErrorCode_640001: 640001,
    // メンテナンス
    sysErrorCode_650001: 650001,
    sysErrorCode_650002: 650002,
    sysErrorCode_650003: 650003,
    sysErrorCode_650004: 650004,
    sysErrorCode_650005: 650005,
    // お知らせ
    sysErrorCode_670001: 670001,
    sysErrorCode_670002: 670002,
    sysErrorCode_670003: 670003,
    sysErrorCode_670004: 670004,
    sysErrorCode_670005: 670005,
    // 強制アップデート
    sysErrorCode_680001: 680001,
    sysErrorCode_680002: 680002,
    // メール履歴
    sysErrorCode_690001: 690001,
    // 使用量ログ出力
    sysErrorCode_700001: 700001
  },

  errorMsg: {
    MSGCRC0001: {
      name: 'MSGCRC0001:<br/>',
      value: '企業ID欄、ユーザID欄、パスワード欄はすべて入力が必要です。<br/>'
    },
    MSGCRC0002: {
      name: 'MSGCRC0002:<br/>',
      value:
        'ログイン認証に失敗しました。<br/>入力内容が正しいかお確かめください。<br/>'
    },
    MSGCRC0003: {
      name: 'MSGCRC0003:<br/>',
      value:
        'テナント共通情報の取得に失敗しました。<br/>システムが利用可能かお確かめください。<br/>'
    },
    MSGCRC0004: {
      name: 'MSGCRC0004:<br/>',
      value:
        '対象が選択されていません。<br/>削除したいデータがある場合、対象にチェックをつけてから削除を選んでください。<br/>'
    },
    MSGCRC0005: {
      name: 'MSGCRC0005:<br/>',
      value:
        'ネットワークに接続されていません。<br/>接続状況をお確かめください。<br/>'
    },
    MSGCRC0006: {
      name: 'MSGCRC0006:<br/>',
      value:
        'エクスポート対象となるデータが存在しませんでした。<br/>条件が正しいかお確かめください。<br/>'
    },
    MSGCRC0007: {
      name: 'MSGCRC0007:<br/>',
      value:
        'お使いのブラウザではエクスポート機能を利用できません。<br/>利用条件の対応ブラウザおよびバージョンをお確かめください。<br/>'
    },
    MSGCRC0008: {
      name: 'MSGCRC0008:<br/>',
      beforeValue: 'インポート対象のデータの',
      afterValue:
        '行目に不正なデータが含まれていたため、処理を続行できません。<br/>対象が正しいかお確かめください。<br/>'
    },
    MSGCRC0009: {
      name: 'MSGCRC0009:<br/>',
      value:
        'インポートデータファイルの形式が正しくありません。<br/>選択したファイルがカンマ区切りテキストファイル(CSV)であるかどうかお確かめください。<br/>'
    },
    MSGCRC0010: {
      name: 'MSGCRC0010:<br/>',
      value:
        'インポートデータファイルの有効レコード数が0件です。<br/>選択したファイルが正しいかどうかお確かめください。<br/>'
    },
    MSGCRC0011: {
      name: 'MSGCRC0011:<br/>',
      value:
        'トップページ情報の取得に失敗しました。<br/>何度かお試しいただいても状況が改善しない場合はシステム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0012: {
      name: 'MSGCRC0012:<br/>',
      value:
        'パスワードの変更に失敗しました。<br/>何度かお試しいただいても状況が改善しない場合はシステム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0013: {
      name: 'MSGCRC0013:<br/>',
      value:
        '現在のパスワードが登録情報と一致しません。<br/>入力内容が正しいかお確かめください。<br/>'
    },
    MSGCRC0014: {
      name: 'MSGCRC0014:<br/>',
      value:
        '端末の登録には端末名が必要です。<br/>入力内容をお確かめください。<br/>'
    },
    MSGCRC0015: {
      name: 'MSGCRC0015:<br/>',
      value:
        '端末の登録には電話番号が必要です。<br/>入力内容をお確かめください。<br/>'
    },
    MSGCRC0016: {
      name: 'MSGCRC0016:<br/>',
      value:
        '端末の登録処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0017: {
      name: 'MSGCRC0017:<br/>',
      value:
        '端末の一覧取得処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0018: {
      name: 'MSGCRC0018:<br/>',
      value:
        '端末の詳細情報の取得処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0019: {
      name: 'MSGCRC0019:<br/>',
      value:
        '端末情報の更新処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0020: {
      name: 'MSGCRC0020:<br/>',
      value:
        '端末情報の削除処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0021: {
      name: 'MSGCRC0021:<br/>',
      value:
        '端末情報のインポート処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0022: {
      name: 'MSGCRC0022:<br/>',
      value:
        '端末情報のエクスポート処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0023: {
      name: 'MSGCRC0023:<br/>',
      value:
        '拠点情報の登録には拠点名が必要です。<br/>入力内容をお確かめください。<br/>'
    },
    MSGCRC0024: {
      name: 'MSGCRC0024:<br/>',
      value:
        '拠点情報の登録には電話番号が必要です。<br/>入力内容をお確かめください。<br/>'
    },
    MSGCRC0026: {
      name: 'MSGCRC0026:<br/>',
      value:
        '拠点情報の登録処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0027: {
      name: 'MSGCRC0027:<br/>',
      value:
        '拠点の一覧取得処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0028: {
      name: 'MSGCRC0028:<br/>',
      value:
        '拠点の詳細情報の取得処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0029: {
      name: 'MSGCRC0029:<br/>',
      value:
        '拠点情報の更新処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0030: {
      name: 'MSGCRC0030:<br/>',
      value:
        '拠点情報の削除処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0031: {
      name: 'MSGCRC0031:<br/>',
      value:
        '拠点情報のインポート処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0032: {
      name: 'MSGCRC0032:<br/>',
      value:
        '拠点情報のエクスポート処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0033: {
      name: 'MSGCRC0033:<br/>',
      value:
        '所属の登録には所属名が必要です。<br/>入力内容をお確かめください。<br/>'
    },
    MSGCRC0034: {
      name: 'MSGCRC0034:<br/>',
      value:
        '所属情報の登録処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0035: {
      name: 'MSGCRC0035:<br/>',
      value:
        '所属の一覧取得処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0036: {
      name: 'MSGCRC0036:<br/>',
      value:
        '所属の詳細情報の取得処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0037: {
      name: 'MSGCRC0037:<br/>',
      value:
        '所属情報の更新処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0038: {
      name: 'MSGCRC0038:<br/>',
      value:
        '所属情報の削除処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0039: {
      name: 'MSGCRC0039:<br/>',
      value:
        '所属情報のインポート処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0040: {
      name: 'MSGCRC0040:<br/>',
      value:
        '所属情報のエクスポート処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0041: {
      name: 'MSGCRC0041:<br/>',
      value:
        'ケアワーカーの登録にはユーザIDが必要です。<br/>入力内容をお確かめください。<br/>'
    },
    MSGCRC0042: {
      name: 'MSGCRC0042:<br/>',
      value:
        'ケアワーカーの登録にはユーザ表示名(名字)が必要です。<br/>入力内容をお確かめください。<br/>'
    },
    MSGCRC0043: {
      name: 'MSGCRC0043:<br/>',
      value:
        'ケアワーカーの登録にはユーザ表示名(名)が必要です。<br/>入力内容をお確かめください。<br/>'
    },
    MSGCRC0044: {
      name: 'MSGCRC0044:<br/>',
      value:
        'ケアワーカーの登録にはユーザ表示名(ふりがな)が必要です。<br/>入力内容をお確かめください。<br/>'
    },
    MSGCRC0045: {
      name: 'MSGCRC0045:<br/>',
      value:
        'ケアワーカーの登録には所属情報が必要です。<br/>入力内容をお確かめください。<br/>'
    },
    MSGCRC0046: {
      name: 'MSGCRC0046:<br/>',
      value:
        'ケアワーカーの登録処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0047: {
      name: 'MSGCRC0047:<br/>',
      value:
        'ケアワーカーの一覧取得処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0048: {
      name: 'MSGCRC0048:<br/>',
      value:
        'ケアワーカーの詳細情報の取得処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0049: {
      name: 'MSGCRC0049:<br/>',
      value:
        'ケアワーカー情報の更新処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0050: {
      name: 'MSGCRC0050:<br/>',
      value:
        'ケアワーカー情報の削除処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0051: {
      name: 'MSGCRC0051:<br/>',
      value:
        'ケアワーカーの顔写真変更処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0052: {
      name: 'MSGCRC0052:<br/>',
      value:
        'ケアワーカーのパスワード初期化処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0053: {
      name: 'MSGCRC0053:<br/>',
      value:
        'ケアワーカーの顔写真には画像ファイル(PNG, JPEG, GIF)を指定してください。<br/>'
    },
    MSGCRC0054: {
      name: 'MSGCRC0054:<br/>',
      value:
        'ケアワーカー情報のインポート処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0055: {
      name: 'MSGCRC0055:<br/>',
      value:
        'ケアワーカー情報のエクスポート処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0056: {
      name: 'MSGCRC0056:<br/>',
      value:
        '評価情報の取得処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0057: {
      name: 'MSGCRC0057:<br/>',
      value:
        '評価の集計対象となるケアワーカー一覧の取得で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0058: {
      name: 'MSGCRC0058:<br/>',
      value:
        '評価の集計対象となる所属一覧の取得で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0059: {
      name: 'MSGCRC0059:<br/>',
      value:
        '評価情報の集計結果エクスポートファイルの作成に失敗しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0060: {
      name: 'MSGCRC0060:<br/>',
      value:
        '評価情報の集計対象は全体集計を合わせて一度に5カテゴリまでです。<br/>6カテゴリ以上の結果が必要な場合は、お手数ですがカテゴリを変更して必要な回数エクスポートを行ってください。<br/>'
    },
    MSGCRC0061: {
      name: 'MSGCRC0061:<br/>',
      value:
        '集計対象期間の開始日は終了日より前になるように指定してください。<br/>'
    },
    MSGCRC0062: {
      name: 'MSGCRC0062:<br/>',
      value:
        '集計する対象カテゴリが一つも選択されていないため、エクスポートできません。<br/>対象カテゴリを5個以内で選択し、もう一度エクスポートを行ってください。<br/>'
    },
    MSGCRC0063: {
      name: 'MSGCRC0063:<br/>',
      value:
        '指定された期間及び対象カテゴリに集計できる情報がありませんでした。<br/>期間または対象カテゴリの指定が誤っていないか確認し、必要があれば変更してもう一度エクスポートを行ってください。<br/>'
    },
    MSGCRC0064: {
      name: 'MSGCRC0064:<br/>',
      value:
        '管理者の登録には管理者IDが必要です。<br/>入力内容をお確かめください。<br/>'
    },
    MSGCRC0065: {
      name: 'MSGCRC0065:<br/>',
      value:
        '管理者の登録には管理者名が必要です。<br/>入力内容をお確かめください。<br/>'
    },
    MSGCRC0066: {
      name: 'MSGCRC0066:<br/>',
      value:
        '管理者の登録にはメールアドレスが必要です。<br/>入力内容をお確かめください。<br/>'
    },
    MSGCRC0067: {
      name: 'MSGCRC0067:<br/>',
      value:
        '変更後のパスワードと確認用パスワードが一致しません。<br/>入力が正しいかもう一度確認をお願いします。<br/>'
    },
    MSGCRC0068: {
      name: 'MSGCRC0068:<br/>',
      value:
        '管理者の登録処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0069: {
      name: 'MSGCRC0069:<br/>',
      value:
        '管理者の一覧取得処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0070: {
      name: 'MSGCRC0070:<br/>',
      value:
        '管理者の詳細情報の取得処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0071: {
      name: 'MSGCRC0071:<br/>',
      value:
        '管理者情報の更新処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0072: {
      name: 'MSGCRC0072:<br/>',
      value:
        '管理者情報の削除処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0073: {
      name: 'MSGCRC0073:<br/>',
      value:
        '管理者情報のエクスポート処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0074: {
      name: 'MSGCRC0074:<br/>',
      value:
        'マスター権限を持つ管理者は削除できません。<br/>選択を外してもう一度お試しください。<br/>'
    },
    MSGCRC0075: {
      name: 'MSGCRC0075:<br/>',
      value:
        '監査ログの取得処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0076: {
      name: 'MSGCRC0076:<br/>',
      value:
        '監査ログ情報のエクスポート処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0077: {
      name: 'MSGCRC0077:<br/>',
      value:
        'ビーコン情報の登録にはビーコンを識別できる名前(設置場所情報など)が必要です。<br/>入力内容をお確かめください。<br/>'
    },
    MSGCRC0078: {
      name: 'MSGCRC0078:<br/>',
      value:
        'ビーコン情報の登録にはビーコンのUUID情報が必要です。<br/>入力内容をお確かめください。<br/>'
    },
    MSGCRC0079: {
      name: 'MSGCRC0079:<br/>',
      value:
        'ビーコン情報の登録処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0080: {
      name: 'MSGCRC0080:<br/>',
      value:
        'ビーコンの一覧取得処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0081: {
      name: 'MSGCRC0081:<br/>',
      value:
        'ビーコンの詳細情報の取得処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0082: {
      name: 'MSGCRC0082:<br/>',
      value:
        'ビーコン情報の更新処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0083: {
      name: 'MSGCRC0083:<br/>',
      value:
        'ビーコン情報の削除処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0084: {
      name: 'MSGCRC0084:<br/>',
      value:
        'ビーコン情報のインポート処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0085: {
      name: 'MSGCRC0085:<br/>',
      value:
        'ビーコン情報のエクスポート処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0086: {
      name: 'MSGCRC0086:<br/>',
      value:
        '共通設定情報の取得処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0087: {
      name: 'MSGCRC0087:<br/>',
      value:
        '自動ログアウト設定の変更処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0088: {
      name: 'MSGCRC0088:<br/>',
      value:
        '評価管理機能利用設定の変更処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください<br/>'
    },
    MSGCRC0089: {
      name: 'MSGCRC0089:<br/>',
      value:
        '操作を行う権限情報が無効となっています。<br/>認証情報の有効期限が切れたかまたは同一ユーザが別のセッションでログインを行った可能性があります。<br/>お手数ですが必要に応じて再度ログインをしてください。<br/>'
    },
    MSGCRC0090: {
      name: 'MSGCRC0090:<br/>',
      value:
        '新しいパスワードが確認用パスワードと一致しません。<br/>入力内容が正しいかお確かめください。<br/>'
    },
    MSGCRC0091: {
      name: 'MSGCRC0091:<br/>',
      value:
        '現在のパスワードが登録情報と同じになっています。<br/>現在設定されているパスワードと同じ値は登録できません。<br/>'
    },
    MSGCRC0092: {
      name: 'MSGCRC0092:<br/>',
      value:
        '入力された電話番号はすでに他の端末、または拠点の電話番号として既に登録されています。<br/>別の電話番号を入力してください。<br/>'
    },
    MSGCRC0093: {
      name: 'MSGCRC0093:<br/>',
      value:
        '入力されたユーザIDはすでに使用されています。<br/>別のユーザIDを入力してください。<br/>'
    },
    MSGCRC0094: {
      name: 'MSGCRC0094:<br/>',
      value:
        '入力された管理者IDはすでに使用されています。<br/>別の管理者IDを入力してください。<br/>'
    },
    MSGCRC0095: {
      name: 'MSGCRC0095:<br/>',
      value: 'パスワード欄もしくは確認用パスワード欄は入力が必要です。<br/>'
    },
    MSGCRC0096: {
      name: 'MSGCRC0096:<br/>',
      value:
        'ログイン処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0097: {
      name: 'MSGCRC0097:<br/>',
      value:
        '端末名が長すぎます。<br/>端末名は30桁以内の文字を登録することができます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0098: {
      name: 'MSGCRC0098:<br/>',
      value:
        '電話番号が長すぎます。<br/>電話番号は13桁以内の数値を登録することができます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0099: {
      name: 'MSGCRC0099:<br/>',
      value:
        '拠点名が長すぎます。<br/>拠点名は30桁以内の文字を登録することができます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0100: {
      name: 'MSGCRC0100:<br/>',
      value:
        '住所が長すぎます。<br/>住所は60桁以内の文字を登録することができます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0101: {
      name: 'MSGCRC0101:<br/>',
      value:
        '所属名が長すぎます。<br/>所属名は30桁以内の文字を登録することができます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0102: {
      name: 'MSGCRC0102:<br/>',
      value:
        'ふりがなが長すぎます。<br/>ふりがなは60桁以内の文字を登録することができます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0103: {
      name: 'MSGCRC0103:<br/>',
      value:
        'ユーザ表示名(名字)が長すぎます。<br/>ユーザ表示名(名字)は15桁以内の文字を登録することができます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0104: {
      name: 'MSGCRC0104:<br/>',
      value:
        'ユーザ表示名(名)が長すぎます。<br/>ユーザ表示名(名)は15桁以内の文字を登録することができます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0105: {
      name: 'MSGCRC0105:<br/>',
      value:
        'ユーザIDが長すぎます。<br/>ユーザIDは16桁以内の文字を登録することができます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0106: {
      name: 'MSGCRC0106:<br/>',
      value:
        '職種が長すぎます。<br/>職種は30桁以内の文字を登録することができます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0107: {
      name: 'MSGCRC0107:<br/>',
      value:
        '役職が長すぎます。<br/>役職は30桁以内の文字を登録することができます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0108: {
      name: 'MSGCRC0108:<br/>',
      value:
        'メイン所属IDが長すぎます。<br/>メイン所属IDは16桁以内の文字を登録することができます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0109: {
      name: 'MSGCRC0109:<br/>',
      value:
        '管理者IDが長すぎます。<br/>管理者IDは16桁以内の文字を登録することができます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0110: {
      name: 'MSGCRC0110:<br/>',
      value:
        '管理者名が長すぎます。<br/>管理者名は30桁以内の文字を登録することができます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0111: {
      name: 'MSGCRC0111:<br/>',
      value:
        'メールアドレスが長すぎます。<br/>メールアドレスは60桁以内の文字を登録することができます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0112: {
      name: 'MSGCRC0112:<br/>',
      value:
        'パスワードが長すぎます。<br/>パスワードは32桁以内の文字を登録することができます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0113: {
      name: 'MSGCRC0113:<br/>',
      value:
        '場所名が長すぎます。<br/>場所名は30桁以内の文字を登録することができます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0114: {
      name: 'MSGCRC0114:<br/>',
      value:
        'UUIDが長すぎます。<br/>UUIDは36桁以内の文字を登録することができます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0115: {
      name: 'MSGCRC0115:<br/>',
      value:
        '企業IDが長すぎます。<br/>企業IDは16桁以内の文字を登録することができます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0116: {
      name: 'MSGCRC0116:<br/>',
      value:
        'メジャー値が長すぎます。<br/>メジャー値は0~65535の数値を登録することができます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0117: {
      name: 'MSGCRC0117:<br/>',
      value:
        'マイナー値が長すぎます。<br/>マイナー値は0~65535の数値を登録することができます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0118: {
      name: 'MSGCRC0118:<br/>',
      value:
        'ケアワーカーの登録にはメイン所属IDまたはメイン所属コードが必要です。<br/>入力内容をお確かめください。<br/>'
    },
    MSGCRC0119: {
      name: 'MSGCRC0119:<br/>',
      value:
        'メジャー値に数値以外が入力されています。<br/>メジャー値は0~65535の数値を登録することができます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0120: {
      name: 'MSGCRC0120:<br/>',
      value:
        'マイナー値に数値以外が入力されています。<br/>マイナー値は0~65535の数値を登録することができます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0121: {
      name: 'MSGCRC0121:<br/>',
      value:
        '端末の更新には電話番号が必要です。<br/>入力内容をお確かめください。<br/>'
    },
    MSGCRC0122: {
      name: 'MSGCRC0122:<br/>',
      value:
        '拠点情報の更新には電話番号が必要です。<br/>入力内容をお確かめください。<br/>'
    },
    MSGCRC0123: {
      name: 'MSGCRC0123:<br/>',
      value:
        '入力されたユーザIDの形式に誤りがあるため、登録することができません。<br/>ユーザIDには半角英数記号をお使い頂けます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0124: {
      name: 'MSGCRC0124:<br/>',
      value:
        '入力された電話番号の形式に誤りがあるため、登録することができません。<br/>電話番号にはハイフン(-)を含めた数字をお使い頂けます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0125: {
      name: 'MSGCRC0125:<br/>',
      value:
        '入力されたパスワードの形式に誤りがあるため、登録することができません。<br/>パスワードには8文字以上の半角英数記号をお使い頂けます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0126: {
      name: 'MSGCRC0126:<br/>',
      value:
        '入力された管理者IDの形式に誤りがあるため、登録することができません。<br/>管理者IDには半角英数記号をお使い頂けます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0127: {
      name: 'MSGCRC0127:<br/>',
      value:
        '入力されたメールアドレスの形式に誤りがあるため、登録することができません。<br/>メールアドレスには半角英数記号をお使い頂けます。<br/>入力内容をご確認の上、正しい形式で入力してください。<br/>'
    },
    MSGCRC0128: {
      name: 'MSGCRC0128:<br/>',
      value:
        'ファイルサイズが1MBを超えているため、画像を登録することができません。<br/>プロフィール画像には1MB以下のファイルをご登録頂けます。<br/>ファイルサイズをご確認の上、再度ご登録ください。<br/>'
    },
    MSGCRC0129: {
      name: 'MSGCRC0129:<br/>',
      value:
        '所属するユーザが存在するため削除することができません。<br/>この所属が本当に不要な場合は、ユーザの所属を変更したうえで削除をお試しください。<br/>'
    },
    MSGCRC0130: {
      name: 'MSGCRC0130:<br/>',
      value:
        '登録対象内で電話番号が重複しています。<br/>同一電話番号を複数の端末や拠点として登録することはできないため、登録内容の見直しを行ってください。<br/>'
    },
    MSGCRC0131: {
      name: 'MSGCRC0131:<br/>',
      value:
        '登録対象内でユーザIDが重複しています。<br/>ユーザIDがユニークとなるよう登録内容の見直しを行ってください。<br/>'
    },
    MSGCRC0132: {
      name: 'MSGCRC0132:<br/>',
      value:
        'ユーザIDには管理者IDを含めて同じIDを登録できません。<br/>IDがユニークとなるよう登録内容の見直しを行ってください。<br/>'
    },
    MSGCRC0133: {
      name: 'MSGCRC0133:<br/>',
      value:
        '管理者IDにはユーザIDを含めて同じIDを登録できません。<br/>IDがユニークとなるよう登録内容の見直しを行ってください。<br/>'
    },
    MSGCRC0134: {
      name: 'MSGCRC0134:<br/>',
      value:
        'アプリパスワード使用設定の変更処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0135: {
      name: 'MSGCRC0135:<br/>',
      value:
        '入力された初期パスワードの形式に誤りがあるため、登録することができません。<br/>初期パスワードには4文字以上の半角英数記号をお使い頂けます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0136: {
      name: 'MSGCRC0136:<br/>',
      value:
        'ご利用されている環境では初期パスワード設定を変更することができません。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0137: {
      name: 'MSGCRC0137:<br/>',
      value:
        '入力された所属IDが存在しないため、登録を行うことができません。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0138: {
      name: 'MSGCRC0138:<br/>',
      value:
        '端末の登録には連携アプリの選択が必要です。<br/>入力内容をお確かめください。<br/>'
    },
    MSGCRC0139: {
      name: 'MSGCRC0139:<br/>',
      beforeValue:
        '通話アプリ区分に無効な値が入力されています。<br/>現在入力可能な区分値は1～',
      afterValue:
        'です。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0140: {
      name: 'MSGCRC0140:<br/>',
      value:
        '改行のみの行がインポートファイル内に含まれているためインポートできません。<br/>改行のみの行を削除するか、正しい値を入力してください。<br/>'
    },
    MSGCRC0141: {
      name: 'MSGCRC0141:<br/>',
      value:
        'アプリログアウト時の文言が長すぎます。<br/>アプリログアウト時の文言は50桁以内の文字を登録することができます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0142: {
      name: 'MSGCRC0142:<br/>',
      value:
        '新しいアプリログアウト文言欄は入力が必要です。<br/>入力内容をお確かめください。<br/>'
    },
    MSGCRC0143: {
      name: 'MSGCRC0143:<br/>',
      value:
        'アプリログアウト文言の変更処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0144: {
      name: 'MSGCRC0144:<br/>',
      value:
        '選択された日付が存在しません。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0145: {
      name: 'MSGCRC0145:<br/>',
      value:
        'キーボードタイプ設定の変更処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0146: {
      name: 'MSGCRC0146:<br/>',
      value:
        '端末登録台数が端末契約台数を超過したため登録できません。<br/>不要な端末を削除するか、契約台数を更新してから登録を行ってください。<br/>'
    },
    MSGCRC0147: {
      name: 'MSGCRC0147:<br/>',
      value:
        '所属の登録には所属コードが必要です。<br/>入力内容をお確かめください。<br/>'
    },
    MSGCRC0148: {
      name: 'MSGCRC0148:<br/>',
      value:
        '所属コードの桁数が不正です。<br/>所属コードは4桁~16桁を登録することができます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0149: {
      name: 'MSGCRC0149:<br/>',
      value:
        '入力された所属コードの形式に誤りがあるため、登録することができません。<br/>所属コードには半角英数をお使い頂けます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0150: {
      name: 'MSGCRC0150:<br/>',
      value:
        '入力された所属コードはすでに使用されています。<br/>別の所属コードを入力してください。<br/>'
    },
    MSGCRC0151: {
      name: 'MSGCRC0151:<br/>',
      value:
        '所属の階層が 4 階層以上となっています。<br/>所属の階層設定は 3 階層まで設定可能です。<br/>'
    },
    MSGCRC0152: {
      name: 'MSGCRC0152:<br/>',
      value:
        '親所属の設定が正しくありません。<br/>自身または自身の配下の所属が親所属となっているため設定できません。<br/>'
    },
    MSGCRC0153: {
      name: 'MSGCRC0153:<br/>',
      value:
        '入力された親所属IDに一致する所属IDが存在しないため、登録を行うことができません。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0154: {
      name: 'MSGCRC0154:<br/>',
      value:
        '入力された親所属コードに一致する所属コードが存在しないため、登録を行うことができません。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0155: {
      name: 'MSGCRC0155:<br/>',
      value:
        'サブ１~４所属の所属名が長すぎます。<br/>所属名は30桁以内の文字を登録することができます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0156: {
      name: 'MSGCRC0156:<br/>',
      value:
        'サブ１~４所属の所属IDが長すぎます。<br/>所属IDは16桁以内の文字を登録することができます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0157: {
      name: 'MSGCRC0157:<br/>',
      value:
        '入力されたサブ１~４所属の所属IDに一致する所属IDが存在しないため、登録を行うことができません。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0158: {
      name: 'MSGCRC0158:<br/>',
      value:
        '入力されたメイン所属コードに一致する所属コードが存在しないため、登録を行うことができません。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0159: {
      name: 'MSGCRC0159:<br/>',
      value:
        '入力されたサブ１~４所属の所属コードに一致する所属コードが存在しないため、登録を行うことができません。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0160: {
      name: 'MSGCRC0160:<br/>',
      value:
        '登録対象の同一ユーザ内でメイン所属ID、サブ１~４所属で所属が重複しています。<br/>同一ユーザ内でメイン所属ID、サブ１~４所属がユニークとなるよう登録内容の見直しを行ってください。<br/>'
    },
    MSGCRC0161: {
      name: 'MSGCRC0161:<br/>',
      value:
        '入力された端末IDの形式に誤りがあるため、登録することができません。<br/>端末IDには半角英数をお使い頂けます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0162: {
      name: 'MSGCRC0162:<br/>',
      value:
        '端末IDが長すぎます。<br/>端末IDは16桁以内の文字を登録することができます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0163: {
      name: 'MSGCRC0163:<br/>',
      value:
        '更新対象内で端末IDが重複しています。<br/>入力内容をお確かめください。<br/>'
    },
    MSGCRC0164: {
      name: 'MSGCRC0164:<br/>',
      value:
        '端末の登録には個人端末フラグが必要です。<br/>入力内容をお確かめください。<br/>'
    },
    MSGCRC0165: {
      name: 'MSGCRC0165:<br/>',
      value:
        '入力された個人端末フラグの形式に誤りがあるため、登録することができません。<br/>個人端末フラグにはtrueまたはfalseをお使い頂けます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0166: {
      name: 'MSGCRC0166:<br/>',
      value:
        '端末の登録には使用アプリ区分が必要です。<br/>入力内容をお確かめください。<br/>'
    },
    MSGCRC0167: {
      name: 'MSGCRC0167:<br/>',
      value:
        '入力された使用アプリ区分の形式に誤りがあるため、登録することができません。<br/>使用アプリ区分には数値をお使い頂けます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0168: {
      name: 'MSGCRC0168:<br/>',
      value:
        '入力された使用アプリ区分に一致する連携アプリのIDが存在しないため、登録を行うことができません。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0169: {
      name: 'MSGCRC0169:<br/>',
      value:
        '入力された拠点IDの形式に誤りがあるため、登録することができません。<br/>拠点IDには半角英数をお使い頂けます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0170: {
      name: 'MSGCRC0170:<br/>',
      value:
        '拠点IDが長すぎます。<br/>拠点IDは16桁以内の文字を登録することができます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0171: {
      name: 'MSGCRC0171:<br/>',
      value:
        '更新対象内で拠点IDが重複しています。<br/>入力内容をお確かめください。<br/>'
    },
    MSGCRC0172: {
      name: 'MSGCRC0172:<br/>',
      value:
        '入力された所属IDの形式に誤りがあるため、登録することができません。<br/>所属IDには半角英数をお使い頂けます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0173: {
      name: 'MSGCRC0173:<br/>',
      value:
        '所属IDが長すぎます。<br/>所属IDは16桁以内の文字を登録することができます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0174: {
      name: 'MSGCRC0174:<br/>',
      value:
        '更新対象内で所属IDが重複しています。<br/>入力内容をお確かめください。<br/>'
    },
    MSGCRC0175: {
      name: 'MSGCRC0175:<br/>',
      value:
        '入力された親所属IDの形式に誤りがあるため、登録することができません。<br/>親所属IDには半角英数をお使い頂けます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0176: {
      name: 'MSGCRC0176:<br/>',
      value:
        '親所属IDが長すぎます。<br/>親所属IDは16桁以内の文字を登録することができます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0177: {
      name: 'MSGCRC0177:<br/>',
      value:
        '入力された親所属コードの形式に誤りがあるため、登録することができません。<br/>親所属コードには半角英数をお使い頂けます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0178: {
      name: 'MSGCRC0178:<br/>',
      value:
        '親所属コードの桁数が不正です。<br/>親所属コードは4桁~16桁を登録することができます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0180: {
      name: 'MSGCRC0180:<br/>',
      value:
        '入力されたメイン所属IDの形式に誤りがあるため、登録することができません。<br/>メイン所属IDには半角英数をお使い頂けます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0181: {
      name: 'MSGCRC0181:<br/>',
      value:
        '入力されたサブ１~４所属の所属IDの形式に誤りがあるため、登録することができません。<br/>所属IDには半角英数をお使い頂けます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0182: {
      name: 'MSGCRC0182:<br/>',
      value:
        '入力されたサブ１~４所属の所属コードの形式に誤りがあるため、登録することができません。<br/>所属コードには半角英数をお使い頂けます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0183: {
      name: 'MSGCRC0183:<br/>',
      value:
        '入力された生年月日の形式に誤りがあるため、登録することができません。<br/>生年月日には日付(yyyy/MM/dd)をお使い頂けます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0184: {
      name: 'MSGCRC0184:<br/>',
      value: '所属が６つ以上選択されています。所属は５つまで設定可能です。<br/>'
    },
    MSGCRC0185: {
      name: 'MSGCRC0185:<br/>',
      beforeValue: '件以上入力されています。<br/>一度に登録できる最大件数は',
      afterValue: '件です。<br/>'
    },
    MSGCRC0186: {
      name: 'MSGCRC0186:<br/>',
      value:
        'サブ１~４所属の所属コードの桁数が不正です。<br/>所属コードは4桁~16桁を登録することができます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0187: {
      name: 'MSGCRC0187:<br/>',
      value:
        'ステータス文言の設定にはステータス１の文言が必要です。<br/>入力内容をお確かめください。<br/>'
    },
    MSGCRC0188: {
      name: 'MSGCRC0188:<br/>',
      value:
        'ステータス１の文言が長すぎます。<br/>ステータス１の文言は全角8桁（または半角16桁）以内の文字を登録することができます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0189: {
      name: 'MSGCRC0189:<br/>',
      value:
        'ステータス文言の設定にはステータス２の文言が必要です。<br/>入力内容をお確かめください。<br/>'
    },
    MSGCRC0190: {
      name: 'MSGCRC0190:<br/>',
      value:
        'ステータス２の文言が長すぎます。<br/>ステータス２の文言は全角8桁（または半角16桁）以内の文字を登録することができます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0191: {
      name: 'MSGCRC0191:<br/>',
      value:
        'ステータス文言の変更処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0192: {
      name: 'MSGCRC0192:<br/>',
      value:
        'ステータス文言の取得処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0193: {
      name: 'MSGCRC0193:<br/>',
      value:
        'ログインユーザの一覧取得処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0194: {
      name: 'MSGCRC0194:<br/>',
      value:
        'ログインユーザの詳細情報の取得処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0195: {
      name: 'MSGCRC0195:<br/>',
      value:
        'インポートファイルに入力した値のデータ型が不正です。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0196: {
      name: 'MSGCRC0196:<br/>',
      value:
        'ケアワーカーの顔写真の取得処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0197: {
      name: 'MSGCRC0197:<br/>',
      value:
        'パスワードが長すぎます。<br/>パスワードは16桁以内の文字を登録することができます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0198: {
      name: 'MSGCRC0198:<br/>',
      value:
        '設定データに不整合が発生しました。所属が重複して設定された状態になっています。<br/>「所属の設定」より再設定しても解消されない場合は、キャンセルし、再度登録を行ってください。<br/>'
    },
    MSGCRC0199: {
      name: 'MSGCRC0199:<br/>',
      beforeValue: '監査ログが',
      middleValue: '件以上あります。<br/>一度に表示できる最大件数は',
      afterValue:
        '件です。<br/>最大件数目以降の監査ログは表示されないため検索条件を変更し、再度検索を行ってください。<br/>'
    },
    MSGCRC0200: {
      name: 'MSGCRC0200:<br/>',
      value:
        '発生日時（開始）は発生日時（終了）より前になるように指定してください。<br/>'
    },
    MSGCRC0201: {
      name: 'MSGCRC0201:<br/>',
      value:
        '更新対象内で所属コードが重複しています。<br/>入力内容をお確かめください。<br/>'
    },
    MSGCRC0202: {
      name: 'MSGCRC0202:<br/>',
      value:
        '監査ログの検索には発生日時（開始）が必要です。入力内容をお確かめください。<br/>'
    },
    MSGCRC0203: {
      name: 'MSGCRC0203:<br/>',
      value:
        '監査ログの検索には発生日時（終了）が必要です。入力内容をお確かめください。<br/>'
    },
    MSGCRC0204: {
      name: 'MSGCRC0204:<br/>',
      value: '強制ログアウトするユーザを選択してください。<br/>'
    },
    MSGCRC0205: {
      name: 'MSGCRC0205:<br/>',
      value:
        'ログインユーザのログアウト処理で異常が発生しました。システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0206: {
      name: 'MSGCRC0206:<br/>',
      value:
        'ふりがなが長すぎます。<br/>ふりがなは30桁以内の文字を登録することができます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0207: {
      name: 'MSGCRC0207:<br/>',
      value:
        '登録する役割名が長すぎます。役割名は10桁以内の文字を登録することができます。入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0208: {
      name: 'MSGCRC0208:<br/>',
      value: '役割の登録には役割名が必要です。入力内容をお確かめください。<br/>'
    },
    MSGCRC0209: {
      name: 'MSGCRC0209:<br/>',
      value:
        '更新予約は処理済みを除き1件のみ登録できます。<br/>更新予約の削除後追加するか、更新予約を編集してください。<br/>'
    },
    MSGCRC0210: {
      name: 'MSGCRC0210:<br/>',
      value: '予約の更新には予約名が必要です。入力内容をお確かめください。<br/>'
    },
    MSGCRC0211: {
      name: 'MSGCRC0211:<br/>',
      value:
        '予約の更新には予約日時が必要です。入力内容をお確かめください。<br/>'
    },
    MSGCRC0212: {
      name: 'MSGCRC0212:<br/>',
      value:
        '予約名が長すぎます。予約名は16桁以内の文字を登録することができます。入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0213: {
      name: 'MSGCRC0213:<br/>',
      value:
        'ファイル名が長すぎます。<br/>ファイル名は拡張子を含む128桁以内の文字を登録することができます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0214: {
      name: 'MSGCRC0214:<br/>',
      value:
        '更新予約の予約日時は現在時刻より後になるように指定してください。<br/>'
    },
    MSGCRC0215: {
      name: 'MSGCRC0215:<br/>',
      value:
        '更新予約の追加処理で異常が発生しました。システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0216: {
      name: 'MSGCRC0216:<br/>',
      value:
        '更新予約の一覧取得処理で異常が発生しました。システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0217: {
      name: 'MSGCRC0217:<br/>',
      value:
        '更新予約の詳細情報の取得処理で異常が発生しました。システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0218: {
      name: 'MSGCRC0218:<br/>',
      value:
        '更新予約の更新処理で異常が発生しました。システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0219: {
      name: 'MSGCRC0219:<br/>',
      value:
        '更新予約の削除処理で異常が発生しました。システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0220: {
      name: 'MSGCRC0220:<br/>',
      value:
        'ファイルのダウンロード処理で異常が発生しました。システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0221: {
      name: 'MSGCRC0221:<br/>',
      value:
        'ファイルの検証処理で異常が発生しました。システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0222: {
      name: 'MSGCRC0222:<br/>',
      value:
        '今日の役割の一覧取得処理で異常が発生しました。システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0223: {
      name: 'MSGCRC0223:<br/>',
      value:
        '今日の役割の詳細情報の取得処理で異常が発生しました。システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0224: {
      name: 'MSGCRC0224:<br/>',
      value:
        '今日の役割の更新処理で異常が発生しました。システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0225: {
      name: 'MSGCRC0225:<br/>',
      value:
        '今日の役割の削除処理で異常が発生しました。システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0226: {
      name: 'MSGCRC0226:<br/>',
      value:
        '今日の役割の追加処理で異常が発生しました。システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0227: {
      name: 'MSGCRC0227:<br/>',
      value:
        'Excelファイルの読み込みに失敗しました。<br/>ファイルをご確認ください。<br/>'
    },
    MSGCRC0228: {
      name: 'MSGCRC0228:<br/>',
      value:
        'ケアワーカーのシートがありません。<br/>ファイルをご確認ください。<br/>'
    },
    MSGCRC0229: {
      name: 'MSGCRC0229:<br/>',
      value: '拠点のシートがありません。<br/>ファイルをご確認ください。<br/>'
    },
    MSGCRC0230: {
      name: 'MSGCRC0230:<br/>',
      value: '所属のシートがありません。<br/>ファイルをご確認ください。<br/>'
    },
    MSGCRC0231: {
      name: 'MSGCRC0231:<br/>',
      beforeValue:
        'ケアワーカーのインポート件数が超過したため更新できません。<br/>最大',
      afterValue: '件までで設定してください。<br/>'
    },
    MSGCRC0232: {
      name: 'MSGCRC0232:<br/>',
      beforeValue:
        '拠点のインポート件数が超過したため更新できません。<br/>最大',
      afterValue: '件までで設定してください。<br/>'
    },
    MSGCRC0233: {
      name: 'MSGCRC0233:<br/>',
      beforeValue:
        '所属のインポート件数が超過したため更新できません。<br/>最大',
      afterValue: '件までで設定してください。<br/>'
    },
    MSGCRC0234: {
      name: 'MSGCRC0234:<br/>',
      beforeValue: '',
      afterValue:
        '行目：所属名が長すぎます。所属名は30桁以内の文字を登録することができます。入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0235: {
      name: 'MSGCRC0235:<br/>',
      beforeValue: '',
      afterValue:
        '行目：ふりがなが長すぎます。ふりがなは60桁以内の文字を登録することができます。入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0236: {
      name: 'MSGCRC0236:<br/>',
      beforeValue: '',
      afterValue:
        '行目：ユーザ表示名(名字)が長すぎます。ユーザ表示名(名字)は15桁以内の文字を登録することができます。入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0237: {
      name: 'MSGCRC0237:<br/>',
      beforeValue: '',
      afterValue:
        '行目：ユーザ表示名(名)が長すぎます。ユーザ表示名(名)は15桁以内の文字を登録することができます。入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0238: {
      name: 'MSGCRC0238:<br/>',
      beforeValue: '',
      afterValue:
        '行目：ユーザIDが長すぎます。ユーザIDは16桁以内の文字を登録することができます。入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0239: {
      name: 'MSGCRC0239:<br/>',
      beforeValue: '',
      afterValue:
        '行目：職種が長すぎます。職種は30桁以内の文字を登録することができます。入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0240: {
      name: 'MSGCRC0240:<br/>',
      beforeValue: '',
      afterValue:
        '行目：役職が長すぎます。役職は30桁以内の文字を登録することができます。入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0241: {
      name: 'MSGCRC0241:<br/>',
      beforeValue: '',
      afterValue:
        '行目：メイン所属IDが長すぎます。メイン所属IDは16桁以内の文字を登録することができます。入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0242: {
      name: 'MSGCRC0242:<br/>',
      beforeValue: '',
      afterValue:
        '行目：電話番号が長すぎます。電話番号は13桁以内の数値を登録することができます。入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0243: {
      name: 'MSGCRC0243:<br/>',
      beforeValue: '',
      afterValue:
        '行目：拠点名が長すぎます。拠点名は30桁以内の文字を登録することができます。入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0244: {
      name: 'MSGCRC0244:<br/>',
      beforeValue: '',
      afterValue:
        '行目：住所が長すぎます。住所は60桁以内の文字を登録することができます。入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0245: {
      name: 'MSGCRC0245:<br/>',
      beforeValue: '',
      afterValue:
        '行目：登録対象内で電話番号が重複しています。同一電話番号を複数の端末や拠点として登録することはできないため、登録内容の見直しを行ってください。<br/>'
    },
    MSGCRC0246: {
      name: 'MSGCRC0246:<br/>',
      beforeValue: '',
      afterValue:
        '行目：入力された拠点IDの形式に誤りがあるため、登録することができません。拠点IDには半角英数をお使い頂けます。入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0247: {
      name: 'MSGCRC0247:<br/>',
      beforeValue: '',
      afterValue:
        '行目：拠点IDが長すぎます。拠点IDは16桁以内の文字を登録することができます。入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0248: {
      name: 'MSGCRC0248:<br/>',
      beforeValue: '',
      afterValue:
        '行目：更新対象内で拠点IDが重複しています。入力内容をお確かめください。<br/>'
    },
    MSGCRC0249: {
      name: 'MSGCRC0249:<br/>',
      beforeValue: '',
      afterValue:
        '行目：所属の登録には所属コードが必要です。入力内容をお確かめください。<br/>'
    },
    MSGCRC0250: {
      name: 'MSGCRC0250:<br/>',
      beforeValue: '',
      afterValue:
        '行目：所属コードの桁数が不正です。所属コードは4桁~16桁を登録することができます。入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0251: {
      name: 'MSGCRC0251:<br/>',
      beforeValue: '',
      afterValue:
        '行目：入力された所属コードの形式に誤りがあるため、登録することができません。所属コードには半角英数をお使い頂けます。入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0252: {
      name: 'MSGCRC0252:<br/>',
      beforeValue: '',
      afterValue:
        '行目：入力された所属コードはすでに使用されています。別の所属コードを入力してください。<br/>'
    },
    MSGCRC0253: {
      name: 'MSGCRC0253:<br/>',
      beforeValue: '',
      afterValue:
        '行目：所属の階層が 4 階層以上となっています。所属の階層設定は 3 階層まで設定可能です。<br/>'
    },
    MSGCRC0254: {
      name: 'MSGCRC0254:<br/>',
      beforeValue: '',
      afterValue:
        '行目：親所属の設定が正しくありません。自身または自身の配下の所属が親所属となっているため設定できません。<br/>'
    },
    MSGCRC0255: {
      name: 'MSGCRC0255:<br/>',
      beforeValue: '',
      afterValue:
        '行目：入力された親所属IDに一致する所属IDが存在しないため、登録を行うことができません。入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0256: {
      name: 'MSGCRC0256:<br/>',
      beforeValue: '',
      afterValue:
        '行目：入力された親所属コードに一致する所属コードが存在しないため、登録を行うことができません。入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0257: {
      name: 'MSGCRC0257:<br/>',
      beforeValue: '',
      afterValue:
        '行目：入力された所属IDの形式に誤りがあるため、登録することができません。所属IDには半角英数をお使い頂けます。入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0258: {
      name: 'MSGCRC0258:<br/>',
      beforeValue: '',
      afterValue:
        '行目：所属IDが長すぎます。所属IDは16桁以内の文字を登録することができます。入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0259: {
      name: 'MSGCRC0259:<br/>',
      beforeValue: '',
      afterValue:
        '行目：更新対象内で所属IDが重複しています。入力内容をお確かめください。<br/>'
    },
    MSGCRC0260: {
      name: 'MSGCRC0260:<br/>',
      beforeValue: '',
      afterValue:
        '行目：入力された親所属IDの形式に誤りがあるため、登録することができません。親所属IDには半角英数をお使い頂けます。入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0261: {
      name: 'MSGCRC0261:<br/>',
      beforeValue: '',
      afterValue:
        '行目：親所属IDが長すぎます。親所属IDは16桁以内の文字を登録することができます。入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0262: {
      name: 'MSGCRC0262:<br/>',
      beforeValue: '',
      afterValue:
        '行目：入力された親所属コードの形式に誤りがあるため、登録することができません。親所属コードには半角英数をお使い頂けます。入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0263: {
      name: 'MSGCRC0263:<br/>',
      beforeValue: '',
      afterValue:
        '行目：親所属コードの桁数が不正です。親所属コードは4桁~16桁を登録することができます。入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0264: {
      name: 'MSGCRC0264:<br/>',
      value:
        '更新処理中のため処理を行えません。<br/>しばらく後に再度実施してください。<br/>'
    },
    MSGCRC0265: {
      name: 'MSGCRC0265:<br/>',
      value:
        'ケアワーカーのインポート処理中のため検証が行えません。<br/>しばらく後に再度実施してください。<br/>'
    },
    MSGCRC0266: {
      name: 'MSGCRC0266:<br/>',
      value:
        '拠点のインポート処理中のため検証が行えません。<br/>しばらく後に再度実施してください。<br/>'
    },
    MSGCRC0267: {
      name: 'MSGCRC0267:<br/>',
      value:
        '所属のインポート処理中のため検証が行えません。<br/>しばらく後に再度実施してください。<br/>'
    },
    MSGCRC0268: {
      name: 'MSGCRC0268:<br/>',
      value:
        '登録可能な役割は最大8件までです。既存の役割を削除してから追加するか、編集してください。<br/>'
    },
    MSGCRC0269: {
      name: 'MSGCRC0269:<br/>',
      value:
        'ファイル形式がExcelではありません。正しいファイルを選択してください<br/>'
    },
    MSGCRC0270: {
      name: 'MSGCRC0270:<br/>',
      value:
        '更新予約の予約日時は現在時刻から180日以内になるように指定してください。<br/>'
    },
    MSGCRC0271: {
      name: 'MSGCRC0271:<br/>',
      value:
        'ファイルサイズが大きすぎます。ファイルサイズは600KB以内を登録することができます。登録内容をご確認の上、正しいファイルを選択してください。<br/>'
    },
    MSGCRC0272: {
      name: 'MSGCRC0272:<br/>',
      value:
        '予約の更新にはファイルを選択が必要です。入力内容をお確かめください。<br/>'
    },
    MSGCRC0273: {
      name: 'MSGCRC0273:<br/>',
      value:
        '補足情報が長すぎます。<br/>補足情報は1024桁以内の文字を登録することができます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0274: {
      name: 'MSGCRC0274:<br/>',
      value:
        'ケアワーカーの顔写真の削除処理で異常が発生しました。システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRC0275: {
      name: 'MSGCRC0275:<br/>',
      value:
        'アカウントがロックされています。<br/>しばらく時間をおいて再操作ください。<br/>'
    },
    MSGCRC0276: {
      name: 'MSGCRC0276:<br/>',
      beforeValue: '',
      afterValue:
        '行目：更新対象内で所属コードが重複しています。<br/>入力内容をお確かめください。<br/>'
    },
    MSGCRC0277: {
      name: 'MSGCRC0277:<br/>',
      beforeValue: '',
      afterValue:
        '行目：所属の登録には所属名が必要です。<br/>入力内容をお確かめください。<br/>'
    },
    MSGCRC0278: {
      name: 'MSGCRC0278:<br/>',
      beforeValue: '',
      afterValue:
        '行目：更新対象内でユーザIDが重複しています。<br/>ユーザIDがユニークとなるよう登録内容の見直しを行ってください。<br/>'
    },
    MSGCRC0279: {
      name: 'MSGCRC0279:<br/>',
      beforeValue: '',
      afterValue:
        '行目：ケアワーカーの登録にはユーザIDが必要です。<br/>入力内容をお確かめください。<br/>'
    },
    MSGCRC0280: {
      name: 'MSGCRC0280:<br/>',
      beforeValue: '',
      afterValue:
        '行目：ケアワーカーの登録にはユーザ表示名(名字)が必要です。<br/>入力内容をお確かめください。<br/>'
    },
    MSGCRC0281: {
      name: 'MSGCRC0281:<br/>',
      beforeValue: '',
      afterValue:
        '行目：ケアワーカーの登録にはユーザ表示名(名)が必要です。<br/>入力内容をお確かめください。<br/>'
    },
    MSGCRC0282: {
      name: 'MSGCRC0282:<br/>',
      beforeValue: '',
      afterValue:
        '行目：ケアワーカーの登録にはユーザ表示名(ふりがな)が必要です。<br/>入力内容をお確かめください。<br/>'
    },
    MSGCRC0283: {
      name: 'MSGCRC0283:<br/>',
      beforeValue: '',
      afterValue:
        '行目：ケアワーカーの登録には所属情報が必要です。<br/>入力内容をお確かめください。<br/>'
    },
    MSGCRC0284: {
      name: 'MSGCRC0284:<br/>',
      value:
        '行目：入力されたユーザIDの形式に誤りがあるため、登録することができません。<br/>ユーザIDには半角英数記号をお使い頂けます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0285: {
      name: 'MSGCRC0285:<br/>',
      beforeValue: '',
      afterValue:
        '行目：サブ１～４所属の所属コードの桁数が不正です。<br/>所属コードは4桁～16桁を登録することができます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0286: {
      name: 'MSGCRC0286:<br/>',
      beforeValue: '',
      afterValue:
        '行目：入力されたサブ１～４所属の所属コードの形式に誤りがあるため、登録することができません。<br/>所属コードには半角英数をお使い頂けます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0287: {
      name: 'MSGCRC0287:<br/>',
      beforeValue: '',
      afterValue:
        '行目：入力されたメイン所属コードに一致する所属コードが存在しないため、登録を行うことができません。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0288: {
      name: 'MSGCRC0288:<br/>',
      beforeValue: '',
      afterValue:
        '行目：入力されたサブ１～４所属の所属コードに一致する所属コードが存在しないため、登録を行うことができません。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0289: {
      name: 'MSGCRC0289:<br/>',
      beforeValue: '',
      afterValue:
        '行目：更新対象の同一ユーザ内でメイン所属、サブ１～４所属で所属が重複しています。<br/>同一ユーザ内でメイン所属、サブ１~４所属がユニークとなるよう登録内容の見直しを行ってください。<br/>'
    },
    MSGCRC0290: {
      name: 'MSGCRC0290:<br/>',
      beforeValue: '',
      afterValue:
        '行目：入力されたユーザIDはすでに使用されています。<br/>別のユーザIDを入力してください。<br/>'
    },
    MSGCRC0291: {
      name: 'MSGCRC0291:<br/>',
      beforeValue: '',
      afterValue:
        '行目：拠点情報の登録には拠点名が必要です。<br/>入力内容をお確かめください。<br/>'
    },
    MSGCRC0292: {
      name: 'MSGCRC0292:<br/>',
      beforeValue: '',
      afterValue:
        '行目：拠点情報の登録には電話番号が必要です。<br/>入力内容をお確かめください。<br/>'
    },
    MSGCRC0293: {
      name: 'MSGCRC0293:<br/>',
      beforeValue: '',
      afterValue:
        '行目：ふりがなが長すぎます。<br/>ふりがなは30桁以内の文字を登録することができます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0294: {
      name: 'MSGCRC0294:<br/>',
      beforeValue: '',
      afterValue:
        '行目：入力された電話番号の形式に誤りがあるため、登録することができません。<br/>電話番号にはハイフン(-)を含めた数字をお使い頂けます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0295: {
      name: 'MSGCRC0295:<br/>',
      beforeValue: '',
      afterValue:
        '行目：補足情報が長すぎます。<br/>補足情報は1024桁以内の文字を登録することができます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0296: {
      name: 'MSGCRC0296:<br/>',
      beforeValue: '更新対象ファイルの<br/>',
      afterValue:
        'に必要な項目が含まれてないため処理を継続できません。<br/>テンプレートに合わせたファイルを登録してください。<br/>'
    },
    MSGCRC0297: {
      name: 'MSGCRC0297:<br/>',
      value:
        '登録されたファイルが見つかりませんでした。<br/>再度ファイルを登録してください。<br/>'
    },
    MSGCRC0298: {
      name: 'MSGCRC0298:<br/>',
      value:
        '紐づいている所属が存在するため削除することができません。<br/>この拠点を削除する場合は、所属の表示拠点を解除後に削除を行ってください。<br/>'
    },
    MSGCRC0299: {
      name: 'MSGCRC0299:<br/>',
      beforeValue: '',
      afterValue:
        '行目：入力された電話番号はすでに他の端末、または拠点の電話番号として登録されています。<br/>別の電話番号を入力してください。<br/>'
    },
    MSGCRC0300: {
      name: 'MSGCRC0300:<br/>',
      beforeValue: '',
      afterValue:
        '行目：入力された生年月日の形式に誤りがあるため、登録することができません。<br/>生年月日には日付(yyyy/MM/dd)をお使い頂けます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRC0301: {
      name: 'MSGCRC0301:<br/>',
      value:
        '画像の読込に失敗しました。<br/>画像ファイルをお確かめください。<br/>'
    }
  },

  sysErrorMsg: {
    MSGCRD0001: {
      name: 'MSGCRD0001:<br/>',
      value:
        'ネットワークに接続されていません。<br/>接続状況をお確かめください。<br/>'
    },
    MSGCRD0002: {
      name: 'MSGCRD0002:<br/>',
      value: 'ユーザID欄、パスワード欄はすべて入力が必要です。<br/>'
    },
    MSGCRD0003: {
      name: 'MSGCRD0003:<br/>',
      value:
        'ログイン認証に失敗しました。<br/>入力内容が正しいかお確かめください。<br/>'
    },
    MSGCRD0004: {
      name: 'MSGCRD0004:<br/>',
      value:
        'ログイン処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRD0005: {
      name: 'MSGCRD0005:<br/>',
      value:
        'パスワードの変更に失敗しました。<br/>何度かお試しいただいても状況が改善しない場合はシステム管理者にお問い合わせください。<br/>'
    },
    MSGCRD0006: {
      name: 'MSGCRD0006:<br/>',
      value:
        'テナントの登録には法人名が必要です。<br/>入力内容をお確かめください。<br/>'
    },
    MSGCRD0007: {
      name: 'MSGCRD0007:<br/>',
      value:
        'テナントの登録には法人住所が必要です。<br/>入力内容をお確かめください。<br/>'
    },
    MSGCRD0008: {
      name: 'MSGCRD0008:<br/>',
      value:
        'テナントの登録には契約日が必要です。<br/>入力内容をお確かめください。<br/>'
    },
    MSGCRD0009: {
      name: 'MSGCRD0009:<br/>',
      value:
        'テナントの登録には法人担当者の氏名が必要です。<br/>入力内容をお確かめください。<br/>'
    },
    MSGCRD0010: {
      name: 'MSGCRD0010:<br/>',
      value:
        'テナントの登録には法人担当者の電話番号が必要です。<br/>入力内容をお確かめください。<br/>'
    },
    MSGCRD0011: {
      name: 'MSGCRD0011:<br/>',
      value:
        'テナントの登録には法人担当者のメールアドレスが必要です。<br/>入力内容をお確かめください。<br/>'
    },
    MSGCRD0012: {
      name: 'MSGCRD0012:<br/>',
      value:
        'テナントの登録には契約台数が必要です。<br/>入力内容をお確かめください。<br/>'
    },
    MSGCRD0013: {
      name: 'MSGCRD0013:<br/>',
      value:
        'テナントの登録にはテナントIDが必要です。<br/>入力内容をお確かめください。<br/>'
    },
    MSGCRD0014: {
      name: 'MSGCRD0014:<br/>',
      value:
        'テナントの登録にはテナント名が必要です。<br/>入力内容をお確かめください。<br/>'
    },
    MSGCRD0015: {
      name: 'MSGCRD0015:<br/>',
      value:
        'テナントの登録には管理者IDが必要です。<br/>入力内容をお確かめください。<br/>'
    },
    MSGCRD0016: {
      name: 'MSGCRD0016:<br/>',
      value:
        'テナントの登録には管理者名が必要です。<br/>入力内容をお確かめください。<br/>'
    },
    MSGCRD0017: {
      name: 'MSGCRD0017:<br/>',
      value:
        'テナントの登録には管理者のメールアドレスが必要です。<br/>入力内容をお確かめください。<br/>'
    },
    MSGCRD0018: {
      name: 'MSGCRD0018:<br/>',
      value:
        'テナントの登録には管理者パスワードが必要です。<br/>入力内容をお確かめください。<br/>'
    },
    MSGCRD0019: {
      name: 'MSGCRD0019:<br/>',
      value:
        'テナントの登録にはアプリ初期パスワードが必要です。<br/>入力内容をお確かめください。<br/>'
    },
    MSGCRD0020: {
      name: 'MSGCRD0020:<br/>',
      value:
        '法人名が長すぎます。<br/>法人名は100桁以内の文字を登録することができます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRD0021: {
      name: 'MSGCRD0021:<br/>',
      value:
        '法人住所が長すぎます。<br/>法人住所は256桁以内の文字を登録することができます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRD0022: {
      name: 'MSGCRD0022:<br/>',
      value:
        '契約日が長すぎます。<br/>契約日は30桁以内の文字を登録することができます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRD0023: {
      name: 'MSGCRD0023:<br/>',
      value:
        '法人担当者の部署名が長すぎます。<br/>法人担当者の部署名は30桁以内の文字を登録することができます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRD0024: {
      name: 'MSGCRD0024:<br/>',
      value:
        '法人担当者の役職が長すぎます。<br/>法人担当者の役職は30桁以内の文字を登録することができます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRD0025: {
      name: 'MSGCRD0025:<br/>',
      value:
        '法人担当者の氏名が長すぎます。<br/>法人担当者の氏名は30桁以内の文字を登録することができます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRD0026: {
      name: 'MSGCRD0026:<br/>',
      value:
        '法人担当者の電話番号が長すぎます。<br/>法人担当者の電話番号は13桁以内の文字を登録することができます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRD0027: {
      name: 'MSGCRD0027:<br/>',
      value:
        '法人担当者のメールアドレスが長すぎます。<br/>法人担当者のメールアドレスは60桁以内の文字を登録することができます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRD0028: {
      name: 'MSGCRD0028:<br/>',
      value:
        '契約台数が長すぎます。<br/>契約台数は30桁以内の文字を登録することができます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRD0029: {
      name: 'MSGCRD0029:<br/>',
      value:
        'テナントIDが長すぎます。<br/>テナントIDは16桁以内の文字を登録することができます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRD0030: {
      name: 'MSGCRD0030:<br/>',
      value:
        'テナント名が長すぎます。<br/>テナント名は30桁以内の文字を登録することができます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRD0031: {
      name: 'MSGCRD0031:<br/>',
      value:
        '管理者IDが長すぎます。<br/>管理者IDは16桁以内の文字を登録することができます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRD0032: {
      name: 'MSGCRD0032:<br/>',
      value:
        '管理者名が長すぎます。<br/>管理者名は30桁以内の文字を登録することができます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRD0033: {
      name: 'MSGCRD0033:<br/>',
      value:
        '管理者のパスワードが長すぎます。<br/>管理者のパスワードは32桁以内の文字を登録することができます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRD0034: {
      name: 'MSGCRD0034:<br/>',
      value:
        '管理者のメールアドレスが長すぎます。<br/>管理者のメールアドレスは60桁以内の文字を登録することができます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRD0035: {
      name: 'MSGCRD0035:<br/>',
      value:
        'テナントの初期ログインパスワードが長すぎます。<br/>初期ログインパスワードは16桁以内の文字を登録することができます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRD0036: {
      name: 'MSGCRD0036:<br/>',
      value:
        '備考が長すぎます。<br/>備考は256桁以内の文字を登録することができます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRD0037: {
      name: 'MSGCRD0037:<br/>',
      value:
        '入力されたテナントIDの形式に誤りがあるため、登録することができません。<br/>テナントIDには半角英数記号をお使い頂けます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRD0038: {
      name: 'MSGCRD0038:<br/>',
      value:
        '入力された電話番号の形式に誤りがあるため、登録することができません。<br/>電話番号にはハイフン(-)を含めた数字をお使い頂けます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRD0039: {
      name: 'MSGCRD0039:<br/>',
      value:
        '入力されたメールアドレスの形式に誤りがあるため、登録することができません。<br/>メールアドレスには半角英数記号をお使い頂けます。<br/>入力内容をご確認の上、正しい形式で入力してください。<br/>'
    },
    MSGCRD0040: {
      name: 'MSGCRD0040:<br/>',
      value:
        '既に登録されているテナントIDと同じため、テナントIDを登録できません。<br/>テナントIDがユニークとなるよう登録内容の見直しを行ってください。<br/>'
    },
    MSGCRD0041: {
      name: 'MSGCRD0041:<br/>',
      value:
        '入力された管理者パスワードの形式に誤りがあるため、登録することができません。<br/>パスワードには8文字以上の半角英数記号をお使い頂けます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRD0042: {
      name: 'MSGCRD0042:<br/>',
      value:
        '入力されたマスター管理者パスワードの形式に誤りがあるため、登録することができません。<br/>パスワードには8文字以上の半角英数記号をお使い頂けます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRD0043: {
      name: 'MSGCRD0043:<br/>',
      value:
        '入力された初期パスワードの形式に誤りがあるため、登録することができません。<br/>初期パスワードには4文字以上の半角英数記号をお使い頂けます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRD0044: {
      name: 'MSGCRD0044:<br/>',
      value:
        'テナント情報の登録処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRD0045: {
      name: 'MSGCRD0045:<br/>',
      value:
        'テナントの一覧取得処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRD0046: {
      name: 'MSGCRD0046:<br/>',
      value:
        'テナントの詳細情報の取得処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRD0047: {
      name: 'MSGCRD0047:<br/>',
      value:
        'テナント情報の更新処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRD0048: {
      name: 'MSGCRD0048:<br/>',
      value:
        'テナント情報の削除処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRD0049: {
      name: 'MSGCRD0049:<br/>',
      value:
        'パスワード認証処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRD0050: {
      name: 'MSGCRD0050:<br/>',
      value:
        'パスワードの変更に失敗しました。<br/>何度かお試しいただいても状況が改善しない場合はシステム管理者にお問い合わせください。<br/>'
    },
    MSGCRD0051: {
      name: 'MSGCRD0051:<br/>',
      value:
        '現在のパスワードが登録情報と一致しません。<br/>入力内容が正しいかお確かめください。<br/>'
    },
    MSGCRD0052: {
      name: 'MSGCRD0052:<br/>',
      value:
        '管理者のパスワード初期化処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRD0053: {
      name: 'MSGCRD0053:<br/>',
      value:
        '変更後のパスワードと確認用パスワードが一致しません。<br/>入力が正しいかもう一度確認をお願いします。<br/>'
    },
    MSGCRD0054: {
      name: 'MSGCRD0054:<br/>',
      value:
        '現在のパスワードが登録情報と同じになっています。<br/>現在設定されているパスワードと同じ値は登録できません。<br/>'
    },
    MSGCRD0055: {
      name: 'MSGCRD0055:<br/>',
      value: 'パスワード欄は入力が必要です。<br/>'
    },
    MSGCRD0056: {
      name: 'MSGCRD0056:<br/>',
      value:
        'マスター管理者パスワードの変更処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRD0057: {
      name: 'MSGCRD0057:<br/>',
      value:
        '重要なお知らせ情報の更新にはタイトルが必要です。<br/>入力内容をお確かめください。<br/>'
    },
    MSGCRD0058: {
      name: 'MSGCRD0058:<br/>',
      value:
        '重要なお知らせ情報の更新には内容が必要です。<br/>入力内容をお確かめください。<br/>'
    },
    MSGCRD0059: {
      name: 'MSGCRD0059:<br/>',
      value:
        'プライバシーポリシーの更新には表示先のURLが必要です。<br/>入力内容をお確かめください。<br/>'
    },
    MSGCRD0060: {
      name: 'MSGCRD0060:<br/>',
      value:
        'EventHubsのSASキーの更新にはSASキーが必要です。<br/>入力内容をお確かめください。<br/>'
    },
    MSGCRD0061: {
      name: 'MSGCRD0061:<br/>',
      value:
        '定義情報の更新処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRD0062: {
      name: 'MSGCRD0062:<br/>',
      value:
        'お知らせの追加にはタイトルが必要です。<br/>入力内容をお確かめください。<br/>'
    },
    MSGCRD0063: {
      name: 'MSGCRD0063:<br/>',
      value:
        'お知らせの追加には表示内容が必要です。<br/>入力内容をお確かめください。<br/>'
    },
    MSGCRD0064: {
      name: 'MSGCRD0064:<br/>',
      value:
        'お知らせの追加処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRD0065: {
      name: 'MSGCRD0065:<br/>',
      value:
        'お知らせが選択されていません。<br/>削除するお知らせを選択後、削除ボタンを押してください。<br/>'
    },
    MSGCRD0066: {
      name: 'MSGCRD0066:<br/>',
      value:
        'お知らせの一覧取得処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRD0067: {
      name: 'MSGCRD0067:<br/>',
      value:
        'お知らせの削除処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRD0068: {
      name: 'MSGCRD0068:<br/>',
      value:
        'マスター管理者のパスワードが長すぎます。<br/>マスター管理者のパスワードは32桁以内の文字を登録することができます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRD0069: {
      name: 'MSGCRD0069:<br/>',
      value:
        '操作を行う権限情報が無効となっています。<br/>認証情報の有効期限が切れたかまたは同一ユーザが別のセッションでログインを行った可能性があります。<br/>お手数ですが必要に応じて再度ログインをしてください。<br/>'
    },
    MSGCRD0070: {
      name: 'MSGCRD0070:<br/>',
      value:
        '入力された管理者IDの形式に誤りがあるため、登録することができません。<br/>管理者IDには半角英数記号をお使い頂けます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRD0071: {
      name: 'MSGCRD0071:<br/>',
      value:
        'メールの送信には件名が必要です。</br>入力内容をお確かめください。</br>'
    },
    MSGCRD0072: {
      name: 'MSGCRD0072:<br/>',
      value:
        'メールの送信には内容が必要です。</br>入力内容をお確かめください。</br>'
    },
    MSGCRD0073: {
      name: 'MSGCRD0073:<br/>',
      value:
        'SendGridの送信処理で異常が発生しました。</br>何度かお試しいただいても状況が改善しない場合はシステム管理者にお問い合わせください。</br>'
    },
    MSGCRD0074: {
      name: 'MSGCRD0074:<br/>',
      value:
        'メール送信処理で異常が発生しました。</br>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。</br>'
    },
    MSGCRD0075: {
      name: 'MSGCRD0075:<br/>',
      value:
        '評価の集計対象となるケアワーカー一覧の取得で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRD0076: {
      name: 'MSGCRD0076:<br/>',
      value:
        '評価の集計対象となる所属一覧の取得で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRD0077: {
      name: 'MSGCRD0077:<br/>',
      value:
        '評価情報の集計対象は全体集計を合わせて一度に5カテゴリまでです。<br/>6カテゴリ以上の結果が必要な場合は、お手数ですがカテゴリを変更して必要な回数エクスポートを行ってください。<br/>'
    },
    MSGCRD0078: {
      name: 'MSGCRD0078:<br/>',
      value:
        '集計対象期間の開始日は終了日より前になるように指定してください。<br/>'
    },
    MSGCRD0079: {
      name: 'MSGCRD0079:<br/>',
      value:
        '評価情報の取得処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRD0080: {
      name: 'MSGCRD0080:<br/>',
      value:
        '位置情報の取得処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRD0081: {
      name: 'MSGCRD0081:<br/>',
      value:
        '集計する対象カテゴリが一つも選択されていないため、エクスポートできません。<br/>対象カテゴリを5個以内で選択し、もう一度エクスポートを行ってください。<br/>'
    },
    MSGCRD0082: {
      name: 'MSGCRD0082:<br/>',
      value:
        '指定された期間及び対象カテゴリに集計できる情報がありませんでした。<br/>期間または対象カテゴリの指定が誤っていないか確認し、必要があれば変更してもう一度エクスポートを行ってください。<br/>'
    },
    MSGCRD0083: {
      name: 'MSGCRD0083:<br/>',
      value:
        'お使いのブラウザではエクスポート機能を利用できません。<br/>利用条件の対応ブラウザおよびバージョンをお確かめください。<br/>'
    },
    MSGCRD0084: {
      name: 'MSGCRD0084:<br/>',
      value:
        '評価情報の集計結果エクスポートファイルの作成に失敗しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRD0085: {
      name: 'MSGCRD0085:<br/>',
      value:
        '連携アプリが一つも選択されていないため登録できません。<br/>連携アプリを選択し、もう一度登録を行ってください。<br/>'
    },
    MSGCRD0086: {
      name: 'MSGCRD0086:<br/>',
      value:
        '現在使用されている連携アプリを削除することはできません。<br/>連携アプリを選択し、もう一度登録を行ってください。<br/>'
    },
    MSGCRD0087: {
      name: 'MSGCRD0087:<br/>',
      value:
        '連携アプリ情報の取得処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRD0088: {
      name: 'MSGCRD0088:<br/>',
      value:
        '管理者の登録にはメールアドレスが必要です。<br/>入力内容をお確かめください。<br/>'
    },
    MSGCRD0089: {
      name: 'MSGCRD0089:<br/>',
      value:
        'メールアドレスが長すぎます。<br/>メールアドレスは60桁以内の文字を登録することができます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRD0090: {
      name: 'MSGCRD0090:<br/>',
      value:
        '入力されたメールアドレスの形式に誤りがあるため、登録することができません。<br/>メールアドレスには半角英数記号をお使い頂けます。<br/>入力内容をご確認の上、正しい形式で入力してください。<br/>'
    },
    MSGCRD0091: {
      name: 'MSGCRD0091:<br/>',
      value: '開始日時もしくは終了日時が正しくありません。<br/>'
    },
    MSGCRD0092: {
      name: 'MSGCRD0092:<br/>',
      value: 'メンテナンス画面に表示するメッセージを入力してください。<br/>'
    },
    MSGCRD0093: {
      name: 'MSGCRD0093:<br/>',
      value: 'メンテナンスするテナントを選択してください。<br/>'
    },
    MSGCRD0094: {
      name: 'MSGCRD0094:<br/>',
      value:
        'メンテナンスの削除処理で異常が発生しました。システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRD0097: {
      name: 'MSGCRD0097:<br/>',
      value: '開始日時もしくは終了日時が正しくありません。<br/>'
    },
    MSGCRD0098: {
      name: 'MSGCRD0098:<br/>',
      value: 'タイトルを入力してください。<br/>'
    },
    MSGCRD0099: {
      name: 'MSGCRD0099:<br/>',
      value: 'メッセージを入力してください。<br/>'
    },
    MSGCRD0100: {
      name: 'MSGCRD0100:<br/>',
      value: '配信するテナントを選択してください。<br/>'
    },
    MSGCRD0101: {
      name: 'MSGCRD0101:<br/>',
      value:
        'お知らせの削除処理で異常が発生しました。システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRD0102: {
      name: 'MSGCRD0102:<br/>',
      value:
        'バージョンのフォーマットが正しくありません。<br/>半角数字で「x.x」の形で入力してください。<br/>'
    },
    MSGCRD0106: {
      name: 'MSGCRD0106:<br/>',
      value:
        'お知らせの一覧取得処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRD0107: {
      name: 'MSGCRD0107:<br/>',
      value:
        'メンテナンスの一覧取得処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRD0108: {
      name: 'MSGCRD0108:<br/>',
      value:
        'バージョン情報取得処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRD0109: {
      name: 'MSGCRD0109:<br/>',
      value:
        'お知らせの追加処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRD0110: {
      name: 'MSGCRD0110:<br/>',
      value:
        'お知らせの更新取得処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRD0111: {
      name: 'MSGCRD0111:<br/>',
      value:
        'お知らせ詳細取得処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRD0112: {
      name: 'MSGCRD0112:<br/>',
      value:
        'メンテナンスの追加処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRD0113: {
      name: 'MSGCRD0113:<br/>',
      value:
        'メンテナンスの更新取得処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRD0114: {
      name: 'MSGCRD0114:<br/>',
      value:
        'メンテナンス詳細取得処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRD0115: {
      name: 'MSGCRD0115:<br/>',
      value:
        '管理者IDがすでに登録されているため更新できません。<br/>別の管理者IDを入力してください。<br/>'
    },
    MSGCRD0116: {
      name: 'MSGCRD0116:<br/>',
      value:
        'メール履歴一覧取得処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRD0117: {
      name: 'MSGCRD0117:<br/>',
      value:
        'メール履歴詳細取得処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRD0118: {
      name: 'MSGCRD0118:<br/>',
      value: '開始日時は終了日時より前になるように指定してください。<br/>'
    },
    MSGCRD0119: {
      name: 'MSGCRD0119:<br/>',
      value:
        'メール履歴の検索には開始日時が必要です。<br/>入力内容をお確かめください。<br/>'
    },
    MSGCRD0120: {
      name: 'MSGCRD0120:<br/>',
      value:
        'メール履歴の検索には終了日時が必要です。<br/>入力内容をお確かめください。<br/>'
    },
    MSGCRD0121: {
      name: 'MSGCRD0121:<br/>',
      value:
        'アカウントがロックされています。<br/>しばらく時間をおいて再操作ください。<br/>'
    },
    MSGCRD0122: {
      name: 'MSGCRD0122:<br/>',
      value:
        '送信に失敗したメールがあります。<br/>メール履歴画面を確認してください。<br/>'
    },
    MSGCRD0123: {
      name: 'MSGCRD0123:<br/>',
      value:
        '契約台数が多すぎます。<br/>契約台数は99999台まで登録することができます。<br/>入力内容をご確認の上、正しい値を入力してください。<br/>'
    },
    MSGCRD0124: {
      name: 'MSGCRD0124:<br/>',
      value:
        '使用量ログの取得処理で異常が発生しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRD0125: {
      name: 'MSGCRD0125:<br/>',
      value:
        'に指定された期間で集計できる情報がありませんでした。<br/>期間の指定が誤っていないか確認し、必要があれば変更してもう一度エクスポートを行ってください。<br/>'
    },
    MSGCRD0126: {
      name: 'MSGCRD0126:<br/>',
      value:
        'お使いのブラウザではエクスポート機能を利用できません。<br/>利用条件の対応ブラウザおよびバージョンをお確かめください。<br/>'
    },
    MSGCRD0127: {
      name: 'MSGCRD0127:<br/>',
      value:
        '使用量ログファイルの作成に失敗しました。<br/>システムが利用可能かお確かめの上、システム管理者にお問い合わせください。<br/>'
    },
    MSGCRD0128: {
      name: 'MSGCRD0128:<br/>',
      value:
        '使用量ログのエクスポートには対象月が必要です。<br/>入力内容をお確かめください。<br/>'
    }
  },
  importErrorNumber: {
    importDeviceNumber: 7,
    importPlaceNumber: 6,
    importPostNumber: 6,
    importUserNumber: 23,
    importBeaconNumber: 4
  },
  requiredItemLabel: '必須',
  exportTitle: {
    deviceTitle:
      '端末ID,端末名,電話番号,個人端末フラグ,使用アプリ区分,登録日時,最終アクセス\r\n',
    placeTitle: '拠点ID,拠点名,ふりがな,電話番号,住所,補足情報\r\n',
    belongTitle: '所属ID,所属コード,所属名,親所属ID,親所属コード,親所属名\r\n',
    careworkerTitle:
      'ユーザID,姓,名,ふりがな,メイン所属ID,メイン所属コード,メイン所属名,サブ１所属ID,サブ１所属コード,サブ１所属名,サブ２所属ID,サブ２所属コード,サブ２所属名,サブ３所属ID,サブ３所属コード,サブ３所属名,サブ４所属ID,サブ４所属コード,サブ４所属名,職種,役職,生年月日,補足情報\r\n',
    adminAccountTitle: '管理者ID,管理者名,メールアドレス,管理者権限情報\r\n',
    auditLogTitle: '発生日時,発生箇所,レベル,メインID,イベントID,補足情報\r\n',
    beaconTitle: 'ビーコンID,場所名\r\n'
  }
}
export const mutations = {}
export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/errorModules/errorMutation.js